/* ==============================================================================
   LUZGURU STORY CARD WEB COMPONENT (VIRAL VIDEOS)
   Asset: assets/lg-story-card.js
============================================================================== */

if (!customElements.get('lg-story-card')) {
  customElements.define('lg-story-card', class LuzguruStoryCard extends HTMLElement {
    constructor() {
      super();
      this.playButton = this.querySelector('.lg-play-btn-v5');
      this.videoBox = this.querySelector('.lg-story-iframe-container-v5');
      this.productId = this.dataset.productId;
      this.videoType = this.dataset.videoType;
      this.videoUrl = this.dataset.videoUrl;

      if (this.playButton) {
        this.playButton.addEventListener('click', this.playVideo.bind(this));
      }
    }

    playVideo(event) {
      if (event) event.preventDefault();
      
      if (!this.videoUrl) return;

      if (this.videoType === 'tiktok') {
        window.open(this.videoUrl, '_blank');
        return;
      }

      // Detener otros videos
      document.querySelectorAll('lg-story-card.is-playing').forEach(activeCard => {
        if (activeCard !== this) {
          activeCard.stopVideo();
        }
      });

      const ytId = this.getYoutubeId(this.videoUrl);
      if (ytId && this.videoBox) {
        this.videoBox.innerHTML = `
          <iframe 
            src="https://www.youtube.com/embed/${ytId}?autoplay=1&controls=0&modestbranding=1&loop=1&playlist=${ytId}&rel=0&playsinline=1" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen
            loading="lazy"
            style="width:100%; height:100%; border:none;"
          ></iframe>
        `;
        this.classList.add('is-playing');
      } else {
        window.open(this.videoUrl, '_blank');
      }
    }

    stopVideo() {
      this.classList.remove('is-playing');
      if (this.videoBox) {
        this.videoBox.innerHTML = '';
      }
    }

    getYoutubeId(url) {
      if (!url) return null;
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
      const match = url.match(regExp);
      return (match && match[2].length === 11) ? match[2] : null;
    }
  });
}
